// extracted by mini-css-extract-plugin
export default {"card":"B4-z"};